import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SalesAgent } from "../../../features/sales/models/sales-agent.model";
import { AdminTemplateSendRequest } from "../models/admin-template-email-request";
import { EmailLog } from "../models/email-log";

@Injectable({
  providedIn: 'root'
})
export class AdminService {
    private http = inject(HttpClient);

    private apiUrl = environment.apiUrl;

    getSalesAgents(): Observable<SalesAgent[]> {
        return this.http.get<SalesAgent[]>(`${this.apiUrl}/sales-agents`);
    }

    getEmailLogs() {
        return this.http.get<EmailLog[]>(`${this.apiUrl}/admin-template/logs`);
    }

    sendTemplate(request: AdminTemplateSendRequest) {
        return this.http.post(`${this.apiUrl}/admin-template/send`, request);
    }
}